/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_View_OrganizerInputs */



/**
* | output |
* | --- |
* | "Organizer view" |
*
* @param {Tournament_View_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_view_organizer = /** @type {((inputs?: Tournament_View_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_View_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue organisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista de organizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visão de organizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vista organizzatore")
	return /** @type {LocalizedString} */ ("Organizer view")
});